export const CURRENCY_SYMBOL = '₹';